<template>
  <!-- 260923 대표 회의: 스마트스토어 오픈 전 QR 현판 사전 신청 바텀시트 — "전화번호로 해 놓으면 담당자가 전화할 거라고",
       "사이즈도 없이 … 순서대로 담당자가 연락을 드릴 것입니다. 이렇게만". 비로그인도 연다(접수 API 무인증). 틀·스타일 = FranchiseRequestSheet. -->
  <div class="modal-dim on">
    <div class="po-sheet-wrap">
      <div class="po-sheet modal">
        <div class="po-sheet__handle" aria-hidden="true"></div>
        <p class="po-sheet__title">{{ title }}</p>
        <p class="po-sheet__lead">스마트스토어 오픈 전까지 사전 신청을 받습니다.<br>연락처를 남겨 주시면 순서대로 담당자가 연락드립니다.</p>

        <label class="po-sheet__label" for="po-phone">연락처</label>
        <input id="po-phone" v-model.trim="form.contactPhone" class="po-sheet__input" type="tel" inputmode="tel" maxlength="20" autocomplete="tel" placeholder="010-0000-0000" />

        <label class="po-sheet__label" for="po-biz">상호 (선택)</label>
        <input id="po-biz" v-model.trim="form.bizName" class="po-sheet__input" type="text" maxlength="60" autocomplete="organization" placeholder="예: 우리집한식당" />

        <p class="po-sheet__notice">남겨 주신 연락처는 사전 신청 안내에만 사용합니다.</p>
        <p v-if="error" class="po-sheet__error" role="alert">{{ error }}</p>
        <button type="button" class="po-sheet__submit" :disabled="busy" @click="submit">{{ busy ? '접수 중…' : '사전 신청하기' }}</button>
        <button type="button" class="po-sheet__close" @click="close">닫기</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import store from '@/store';
import { showTextModal } from '@/common/utils/ModalState';

const props = defineProps(['data']);
const emits = defineEmits(['close']);

const title = props.data?.product ? `${props.data.product} 사전 신청` : 'QR 현판 사전 신청';
const form = reactive({
  contactPhone: store.getters['user/getUserData']?.phone || '',
  bizName: props.data?.bizName || ''
});
const busy = ref(false);
const error = ref('');

// 200ms = dim 페이드 아웃 대기(하우스 모달 패턴)
const close = () => { setTimeout(() => emits('close'), 200); };

const submit = async () => {
  if (busy.value) return;
  error.value = '';
  const digits = String(form.contactPhone || '').replace(/\D/g, '');
  if (!/^0\d{8,10}$/.test(digits)) { error.value = '연락처를 다시 확인해 주세요.'; return; }
  busy.value = true;
  const r = await store.dispatch('business/submitQrPreOrder', {
    contactPhone: digits,
    bizName: form.bizName || null,
    product: props.data?.product || null,
    entry: props.data?.entry || null
  });
  busy.value = false;
  if (!r.ok) { error.value = r.message; return; }
  close();
  showTextModal('사전 신청이 접수되었습니다.\n순서대로 담당자가 연락드립니다.', '확인');
};
</script>

<style scoped>
.po-sheet-wrap { position: absolute; inset: 0; z-index: 1; display: flex; align-items: flex-end; justify-content: center; }
.po-sheet.modal {
  --blue-dark: #306DF7;
  --wash: #F7F8FA;
  --ink: #1F212A;
  --body: #3D3F4D;
  --muted: #737687;
  --navy: #0F1F3D;
  box-sizing: border-box;
  width: 100%; min-width: 0; max-width: 600px; max-height: 90%;
  overflow-y: auto; overscroll-behavior-y: contain;
  padding: 12px 20px calc(20px + env(safe-area-inset-bottom));
  border-radius: 16px 16px 0 0; background: #fff;
  box-shadow: 0 -8px 32px rgba(15, 31, 61, .12);
  color: var(--ink); font-family: 'Pretendard', system-ui, -apple-system, sans-serif;
  font-size: 16px; line-height: 1.5; letter-spacing: -0.02em; text-align: left;
  animation: sheetUp .25s ease;
}
.po-sheet > * { flex-shrink: 0; }
@keyframes sheetUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
.po-sheet__handle { width: 40px; height: 4px; margin: 0 auto 20px; border-radius: 2px; background: #CDD1DA; }
.po-sheet__title { margin: 0 0 6px; color: var(--navy); font-size: 22px; font-weight: 800; line-height: 1.4; word-break: keep-all; }
.po-sheet__lead { margin: 0 0 8px; color: var(--body); font-size: 16px; line-height: 1.5; word-break: keep-all; overflow-wrap: anywhere; }
.po-sheet__label { display: block; margin: 20px 0 8px; color: var(--ink); font-size: 16px; font-weight: 700; line-height: 1.5; }
.po-sheet__input { box-sizing: border-box; width: 100%; min-width: 0; min-height: 52px; padding: 12px 14px; border: 1px solid #CFD3DC; border-radius: 12px; background: var(--wash); color: var(--ink); font-family: inherit; font-size: 16px; line-height: 1.5; }
.po-sheet__input::placeholder { color: var(--muted); opacity: 1; }
.po-sheet__input:focus { border-color: var(--blue-dark); background: #fff; }
.po-sheet__notice { margin: 16px 0 0; color: var(--body); font-size: 16px; line-height: 1.5; word-break: keep-all; }
.po-sheet__error { margin: 12px 0 0; padding: 12px; border-radius: 12px; background: #FFF3F3; color: #B33232; font-size: 16px; line-height: 1.5; }
.po-sheet__submit, .po-sheet__close { width: 100%; min-height: 52px; padding: 12px 16px; border: 0; border-radius: 16px; font-family: inherit; font-size: 17px; font-weight: 700; line-height: 1.5; text-decoration: none; cursor: pointer; }
.po-sheet__submit { margin-top: 24px; background: var(--blue-dark); color: #fff; }
.po-sheet__submit:disabled { background: #DDE6F8; color: #526582; cursor: wait; }
.po-sheet__close { margin-top: 8px; background: var(--wash); color: var(--body); }
.po-sheet__input:focus-visible, .po-sheet__submit:focus-visible, .po-sheet__close:focus-visible { outline: 3px solid var(--navy); outline-offset: 2px; }
.po-sheet__submit:not(:disabled):active, .po-sheet__close:active { filter: brightness(.95); }
@media (max-width: 374px) { .po-sheet.modal { padding-right: 16px; padding-left: 16px; } }
@media (prefers-reduced-motion: reduce) { .po-sheet.modal { animation: none; } }
</style>
